import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Fusionne les classes Tailwind en laissant la dernière gagner. */
export function cn(...entrees: ClassValue[]): string {
  return twMerge(clsx(entrees));
}

/** Retarde l'exécution — utilisé par les champs de recherche. */
export function debounce<A extends unknown[]>(
  fn: (...args: A) => void,
  delai = 300,
): (...args: A) => void {
  let minuteur: ReturnType<typeof setTimeout> | undefined;
  return (...args: A) => {
    if (minuteur) clearTimeout(minuteur);
    minuteur = setTimeout(() => fn(...args), delai);
  };
}
